"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgReviewCardMobileSkeleton = function SvgReviewCardMobileSkeleton(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 367 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 367,
    height: 220,
    rx: 6,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E9ED",
    d: "M8 28h180v1H8zM57 55h80v1H57zM57 72h150v1H57zM8 132h206v1H8zM8 206h150v1H8zM8 100h343v1H8zM8 164h316v1H8zM8 148h343v1H8zM8 116h316v1H8zM8 180h343v1H8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 60,
    r: 20,
    fill: "#E6E9ED"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgReviewCardMobileSkeleton);
var _default = exports["default"] = Memo;